import { CLEAR_ANSWERS, CLEAR_ANSWERS_SUCCESS, END_SESSION, END_SESSION_SUCCESS, SUBMIT_STUDENTS, SUBMIT_STUDENTS_ERROR, SUBMIT_STUDENTS_SUCCESS } from "../action/studentAction";


let initialState = {
    loading:false,
    error: "",
    students: [],
    endingSession: false,
    clearingResult: false,
}


export default function studentsReducer(state = initialState,action){
    switch(action.type){
        case SUBMIT_STUDENTS:
            return {...state, loading: true}
        case SUBMIT_STUDENTS_ERROR:
            return {...state, loading: false, error: action.payload}
        case SUBMIT_STUDENTS_SUCCESS:
            return {...state, loading: false, students: action.payload}
        case END_SESSION:
            return {...state, endingSession:true}
        case END_SESSION_SUCCESS:
            return {...state, endingSession:false, students:[]}
        case CLEAR_ANSWERS:
            return {...state, clearingResult:true};
        case CLEAR_ANSWERS_SUCCESS:
            return {...state, clearingResult:false};
        default:
            return state;
    }
}